<template>
	<el-form-item label="占位内容">
		<el-input v-model="data.options.placeholder" />
	</el-form-item>

	<el-form-item label="默认值">
		<el-input v-model="data.options.defaultValue" />
	</el-form-item>

	<el-form-item label="最大长度">
		<el-input-number v-model="data.options.maxlength" :min="0" />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemInput',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
